import { Grid } from 'antd';

/**
 * UNA SOLA FUENTE DE VERDAD sobre "esto es un telefono" DENTRO DEL PANEL.
 *
 * El micrositio publico corta distinto y a proposito: `pages/Micrositio/
 * AnimalPage.jsx` llama a `Grid.useBreakpoint()` directo y usa `md` (768px)
 * porque se pregunta OTRA cosa —si la tabla entra, para cambiarla por cards—,
 * no si el sidebar tiene que colapsar. No unificar: un `useEsMobile(breakpoint)`
 * parametrizado deja de significar algo. Dos preguntas distintas, dos umbrales.
 *
 * POR QUE EXISTE: `useSidebarResponsive` ya tenia esta logica adentro, con su
 * razonamiento documentado. Cuando aparecio el segundo consumidor
 * (`useColumnasResponsive`, para las tablas) habia dos caminos: copiar las dos
 * lineas, o extraerlas. Copiarlas contradecia el comentario que el propio
 * `useSidebarResponsive` ya tenia escrito —"la unica fuente de verdad sobre
 * mobile es Grid.useBreakpoint"— porque pasarian a ser dos lugares donde
 * cambiar el breakpoint. Se extrajo.
 *
 * EL BREAKPOINT ES `lg` (992px) A PROPOSITO: las media queries que ya existen
 * en `index.css` usan `max-width: 991px`, que es exactamente `screenLG - 1` de
 * antd. Usando `lg`, el JS y el CSS cortan en el mismo lugar; con cualquier
 * otro habria un rango donde uno dice mobile y el otro dice desktop.
 *
 * LA COMPARACION ES CONTRA `false` EXPLICITO, no `!screens.lg`: `useBreakpoint`
 * arranca devolviendo `{}` y recien se suscribe en un `useLayoutEffect`, asi
 * que en el PRIMER render `screens.lg` es `undefined`. Con la negacion ese
 * render daria "mobile" en una pantalla de escritorio. Al ser `useLayoutEffect`
 * la correccion entra antes del paint: no hay parpadeo, y el default de ese
 * render intermedio es desktop, que es el comportamiento que la app ya tenia.
 */
export default function useEsMobile() {
  const screens = Grid.useBreakpoint();
  return screens.lg === false;
}
